import { accountService } from '@/service/account';

export interface AccountData {
  id: number,
  slug: string;
  email: string;
  first_name: string;
  last_name: string;
  password?: string;
  role: number;
  role_name?: string,
  organizations?: string;
  created?: Date;
  updated?: Date;
}
export enum AccountRole {
  SUPER_ADMIN = 255,
  ORGANIZATION_ADMIN = 100,
  USER = 0,
}

export const RoleLabel: { [K in AccountRole]: string } = {
  [AccountRole.SUPER_ADMIN]: 'Super Admin',
  [AccountRole.ORGANIZATION_ADMIN]: 'Organization Admin',
  [AccountRole.USER]: 'User',
};
export class Account {
  constructor(private slug?: string) { }

  async all(): Promise<AccountData[] | undefined> {
    try {
      return await accountService.getAll() as AccountData[];
    } catch (e) {
      console.warn(e);
      throw e;
    }
  }

  async get(): Promise<AccountData | undefined> {
    try {
      return await accountService.getOne(`${this.slug}`) as AccountData;
    } catch (e) {
      console.warn(e);
    }
  }
  async getByToken(): Promise<AccountData | any> {
    try {
      return await accountService.getByToken();
    } catch (e) {
      console.warn(e);
    }
  }

  async add(project: AccountData): Promise<string | undefined> {
    try {
      return await accountService.add(project);
    } catch (e: any) {
      if (e.response?.data?.message) {
        throw new Error(e.response.data.message);
      }
      throw e;
    }
  }

  async update(project: AccountData): Promise<string | undefined> {
    try {
      return await accountService.update(`${this.slug}`, project);
    } catch (e: any) {
      if (e.response?.data?.message) {
        throw new Error(e.response.data.message);
      }
      throw e;
    }
  }

  async delete(): Promise<boolean> {
    try {
      return await accountService.delete(`${this.slug}`)
    } catch (e: any) {
      if (e.response?.data?.message) {
        throw new Error(e.response.data.message);
      }
      throw e;
    }
  }
}

